import React from 'react';
import { TabDef, TabId } from '../types/chatbot.types';

interface ChatbotConfigTabsProps {
  tabs: TabDef[];
  activeTab: TabId;
  onTabChange: (tabId: TabId) => void;
}

const ChatbotConfigTabs: React.FC<ChatbotConfigTabsProps> = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="bg-white rounded-xl border shadow-sm mb-6">
      <div className="border-b border-agentic-gray-200">
        <nav className="flex space-x-8 px-6" aria-label="Tabs">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => onTabChange(tab.id)}
                className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                  isActive
                    ? 'border-agentic-primary-blue text-agentic-primary-blue'
                    : 'border-transparent text-agentic-text-secondary hover:text-agentic-text-primary hover:border-agentic-gray-300'
                }`}
              >
                <Icon className="h-5 w-5 inline mr-2" />
                {tab.label}
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default ChatbotConfigTabs;
